import { useState } from 'react';

import RadioGroup from '@/v2/components/Cards/RadioCard/RadioGroup';
import RadioCard from '@/v2/components/Cards/RadioCard/RadioCard';
import Text from '@/v2/components/Typography/Text';

export default function SurveyStepOptionsSingle({
  options,
  size = 'default',
  children,
}) {
  const textVariant = size == 'compact' ? 'grey-14-semi' : 'dm-16-medium';
  const [selected, setSelected] = useState(null);

  return children({
    disabled: !selected,
    answers: selected,
    content: (
      <RadioGroup variant="vertical" size={size}>
        {options.map((option) => (
          <RadioCard
            key={option.value}
            selected={selected == option.value}
            onSelect={() => setSelected(option.value)}
            variant="horizontal"
            size={size}
            ariaLabel={option.label}
            testId={option.value}
          >
            <Text variant={textVariant} color="black">
              {option.label}
            </Text>
          </RadioCard>
        ))}
      </RadioGroup>
    ),
  });
}
